import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as zephyr from './zephyr';
import * as tios from './tios';

export default class SocketNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Socket Send';
        this.id = 'node_socket';
        this.linkedFeature = 'general';
        this.icon = 'HiCommandLine';

        this.inputs = [
            {
                name: 'Send Data',
                portId: 'sock_send',
                params: [
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'SOCKET',
                name: 'Socket',
                settingType: SettingType.OPTION,
                refId: 'socket_connection',
                required: true,
                default: '',
                options: [],
            },
            {
                id: 'DATA',
                name: 'Data',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
            if (SOCKET) {
                return `SOCKET ${SOCKET.getSettingValue('NAME')} send`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
        if (SOCKET) {
            return `SOCKET ${SOCKET.getSettingValue('NAME')} send`;
        }
        return super.getName();
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
